export default __webpack_public_path__ + "static/outer@2x-408fc2c079f45c0ad7daa6ebd77dc913.png";